/* @ngInject */
const settingMenu = (
  $state,
  labels,
  routes
) => {
  const self = {}

  self.radio = {
    value: 'general',
  }

  self.items = {
    general: {
      ref: 'general',
      label: labels.setting.general,
      go: () => {
        $state.go(routes.setting.general.index.path)
      },
    },
    display: {
      ref: 'display',
      label: labels.setting.display,
      go: () => {
        $state.go(routes.setting.display.index.path)
      },
    },
  }

  return self
}

export default settingMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/setting.menu.js